import {
    makeExecutorUrl,
    trans,
} from '@frontend/helpers'
import {ServicesListItemIcons} from '@frontend/modules/public/services/components/list/ServicesListItemIcons'
import type {ExecutorPreviewData} from '@frontend/modules/public/services/ServicesModuleTypes'
import {
    mdiFire,
    mdiHeart,
    mdiStar,
} from '@mdi/js'
import {Link} from 'react-router-dom'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {Tooltip} from 'swayok-react-mdb-ui-kit/components/Tooltip/Tooltip'

interface Props {
    executor: ExecutorPreviewData
    example?: boolean
}

// Карточка предпросмотра исполнителя в категории услуг.
export function ServicesListItemCoverImageAndIcons(props: Props) {

    const {
        executor,
        example,
    } = props

    return (
        <div className="d-flex flex-column align-items-center">
            <div className="executor-card-image-and-icons">
                <Link
                    to={makeExecutorUrl(executor.slugWithId, executor.categorySlugWithId)}
                    style={{
                        backgroundImage: `url("${executor.cover}")`,
                    }}
                    target="_blank"
                    rel="noreferrer"
                    className="executor-card-image rounded-6 shadow-3"
                    onClick={
                        example
                            ? event => event.preventDefault()
                            : undefined
                    }
                />
                {executor.isPromoted && (
                    <div className="executor-card-promoted-label bg-orange rounded-end ps-1 pe-2 fs-7 with-icon-flex fw-500 text-dark">
                        <Icon
                            path={mdiFire}
                            size={20}
                            color="dark"
                        />
                        HOT!
                    </div>
                )}
                <ServicesListItemIcons
                    executor={executor}
                    liked={executor.isFavourite}
                    disabled={example}
                />
                <div className="mt-2 d-flex flex-row justify-content-center gap-4">
                    <div className="with-icon-flex">
                        {executor.likesCount ?? 0}
                        <Icon
                            path={mdiHeart}
                            size={20}
                            color="muted"
                            className="ms-2"
                        />
                    </div>
                    {executor.rating > 0 && (
                        <Tooltip
                            title={trans().reviews.reviews_count(executor.reviewsCount)}
                            className="with-icon-flex"
                        >
                            {executor.rating}
                            <Icon
                                path={mdiStar}
                                size={20}
                                color="orange"
                                className="ms-1"
                            />
                        </Tooltip>
                    )}
                </div>
            </div>
        </div>
    )
}
